import {ISimplePresentation, ISimplePresentationRunnerController} from "../SimplePresentationRunner";
import {Game} from "../Game";
import {gsap} from "gsap";
import {Sound} from "../sound/Sound";
import {INormalWinConfig, NORMAL_WIN_LEVEL_NAMES} from "../server/IData";

export class NormalWinRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return Game.model.isNormalWin && !Game.isMaxWinByMXSymbol();
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
                onComplete: () => {
                    controller.finish();
                }
            }),
            winRatio: number = Game.model.winRatio,
            totalSpinWinnings: number = Game.model.gameData.spinWin,
            isSingleWinBelowStake: boolean = Game.isSingleWinBelowStake();
        let {duration: countUpDuration, name: winLvlName} = this.getNormalWinConfig(winRatio);

        tl.add(() => {
            controller.setSkipCallback(() => {
                this.onSkip(tl);
            });
        });

        tl.to(this, {
            duration: 0.01
        });

        if (!isSingleWinBelowStake) {
            Game.countUp.preCalculateScale(0, totalSpinWinnings);

            if (countUpDuration > 0.1) {
                // #174
                countUpDuration *= 2;

                if (winLvlName === NORMAL_WIN_LEVEL_NAMES.LARGE) {
                    Game.soundPlayer.playSound(Sound.WIN_LARGE_COUNTUP, 1);
                } else if (winLvlName === NORMAL_WIN_LEVEL_NAMES.MEDIUM){
                    Game.soundPlayer.playSound(Sound.WIN_MID_COUNTUP, 1);
                } else if (winLvlName === NORMAL_WIN_LEVEL_NAMES.SMALL){
                    Game.soundPlayer.playSound(Sound.WIN_SMALL_COUNTUP, 1);
                }

                tl.add([
                    () => {
                        Game.countUp.stopAt(0);
                        Game.countUp.getReady(330);
                    },
                    Game.countUp.getCountAnimation(0, totalSpinWinnings, countUpDuration)
                ]);
            } else {
                tl.add(() => {
                    Game.countUp.getReady(330);
                    Game.countUp.stopAt(totalSpinWinnings);
                });
            }
        }

        tl.add(() => {
            if (!isSingleWinBelowStake) {
                if (winLvlName === NORMAL_WIN_LEVEL_NAMES.LARGE) {
                    Game.soundPlayer.playSound(Sound.WIN_LARGE, 1);
                } else if (winLvlName === NORMAL_WIN_LEVEL_NAMES.MEDIUM) {
                    Game.soundPlayer.playSound(Sound.WIN_MID, 1);
                } else if (winLvlName === NORMAL_WIN_LEVEL_NAMES.SMALL) {
                    Game.soundPlayer.playSound(Sound.WIN_SMALL, 1);
                } else if (winLvlName === NORMAL_WIN_LEVEL_NAMES.TINY) {
                    Game.soundPlayer.playSound(Sound.WIN_TINY, 1);
                }
                Game.countUp.stopAt(totalSpinWinnings);
            }
            Game.keypadPlugin.setWin(Game.model.gameData.accumulatedRoundWin, true, Game.isWinBelowStake());
        });

        if (winLvlName !== NORMAL_WIN_LEVEL_NAMES.TINY) {
            tl.add(Game.countUp.playEndEffect(), "<");
        }
        tl.to(this, {
            duration: 0.5
        }, "<");

        tl.to(Game.countUp, {
            duration: 0.5,
            alpha: 0
        });
        tl.add(() => {
            Game.countUp.visible = false;
        });
    }

    public getNormalWinConfig(winRatio: number): INormalWinConfig {
        const ratio: number = winRatio;

        if (ratio >= 5) {
            return {
                duration: 0.8,
                name: NORMAL_WIN_LEVEL_NAMES.LARGE
            };
        } else if (ratio >= 3) {
            return {
                duration: 0.5,
                name: NORMAL_WIN_LEVEL_NAMES.MEDIUM
            };
        } else if (ratio > 1) {
            return {
                duration: 0.2,
                name: NORMAL_WIN_LEVEL_NAMES.SMALL
            };
        } else {
            return {
                duration: 0.001,
                name: NORMAL_WIN_LEVEL_NAMES.TINY
            };
        }
    }

    private onSkip(tl: gsap.core.Timeline): void {
        tl.totalProgress(1);
    }
}